import { useCallback, useState } from "react";

export function useDialog(init = false) {
  const [state, setState] = useState({
    open: init,
    data: undefined,
  });

  const handleOpen = useCallback(
    (data) => {
      setState({
        open: true,
        data,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleClose = useCallback(
    (dispose = false) => {
      setState({
        open: false,
        data: dispose ? undefined : state.data,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return {
    data: state.data,
    handleClose,
    handleOpen,
    open: state.open,
  };
}
